import { MonitoringSearchCTO } from "./searchCto"


export const resolveThingNameRedux = (
  thingId: number,
  actionType: string,

) => {
  window.parent.primingcloudRedux.monitoring.resolveThingName(
    thingId,
    actionType,
  )
}

export const resolveParameterNameRedux = (
  parameterId: number,
  actionType: string,


) => {
  window.parent.primingcloudRedux.monitoring.resolveParameterName(
    parameterId,
    actionType,
  )
}

export const resolveParameterNamesRedux = (
  parameterIds: number[],
  actionType: string,


) => {
  window.parent.primingcloudRedux.monitoring.resolveParameterNames(
    parameterIds,
    actionType,
  )

}

export const resolvePoolNameRedux = (
  poolId: number,
  actionType: string,


) => {

  window.parent.primingcloudRedux.monitoring.resolvePoolName(
    poolId,
    actionType,

  )

}

export const searchMonitoringMessagesRedux = (
  searchCTO: any,
  actionType: string,


) => {
  window.parent.primingcloudRedux.monitoring.searchMonitoringMessages(
    searchCTO,
    actionType,


  )
}

export const getMonitoringSeveritiesRedux = (
  actionType: string,
) => {
  window.parent.primingcloudRedux.monitoring.getMonitoringSeverities(
    actionType,
  )
}

export const resolveMonitoringSeverityRedux = (
  severity: string,
  actionType: string,
) => {
  window.parent.primingcloudRedux.monitoring.resolveMonitoringSeverity(
    severity,
    actionType,

  )
}

export const getMonitoringOperationsRedux = (
  actionType: string,
) => {
  window.parent.primingcloudRedux.monitoring.getMonitoringOperations(
    actionType,

  )
}

export const resolveMonitoringOperationRedux = (
  operation: string,
  actionType: string,
) => {
  window.parent.primingcloudRedux.monitoring.resolveMonitoringOperation(
    operation,
    actionType,

  )
}

export const loadUsageRedux = (
  search: any,
  actionType: string,

) => {
  window.parent.primingcloudRedux.monitoring.loadUsage(
    search,
    actionType,

  )
}

export const getMonitoringObjectTypesRedux = (
  actionType: string,


) => {
  window.parent.primingcloudRedux.monitoring.getMonitoringObjectTypes(
    actionType,


  )
}

export const resolveMonitoringObjectTypeRedux = (
  objectType: string,
  actionType: string,


) => {
  window.parent.primingcloudRedux.monitoring.resolveMonitoringObjectType(
    objectType,
    actionType,


  )
}

export const getSearchCTO  = () =><MonitoringSearchCTO>
<unknown>{
  return: <MonitoringSearchCTO>window.parent.primingcloud.monitoring.getSearchCTO()
}